import {
	Accordion,
	FlavourIcon,
	ToggleGroup,
} from "@au-schein-de/au-ui-library";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { FilterHeader } from "../filter-header.component";
import { useFiltersContext } from "../filters.context";

export function FlavorsFilter() {
	const { t } = useTranslation("product");
	const { filters, config, onFilterChange, facets } = useFiltersContext();
	const value = filters.flavors ?? [];
	const facetCounts = facets?.flavors;

	const getCount = (flavor: string): number | undefined => {
		if (!facetCounts?.length) return undefined;
		return facetCounts.find((f) => f.value === flavor)?.count ?? 0;
	};

	const sortedFlavors = useMemo(() => {
		// @ts-ignore: dynamic key generation
		const translate = (key: string) => t(`filters.flavors.${key}`) as string;
		return [...(config.flavors ?? [])].sort((a, b) => {
			const translatedA = translate(a);
			const translatedB = translate(b);
			return translatedA.localeCompare(translatedB);
		});
	}, [config.flavors, t]);

	return (
		<Accordion.Item
			value="flavors"
			variant="filter"
			data-testid="flavors-filter"
		>
			<Accordion.Trigger variant="filter" data-testid="flavors-filter-trigger">
				<FilterHeader
					title={t("filters.flavors")}
					value={Number(value?.length)}
					icon={<FlavourIcon size={5} />}
				/>
			</Accordion.Trigger>
			<Accordion.Content variant="filter">
				<ToggleGroup.Root
					type="multiple"
					variant="secondary"
					size="xs"
					className="flex-wrap justify-start gap-2 pt-3"
					value={value}
					onValueChange={(val) => onFilterChange("flavors", val)}
				>
					{sortedFlavors.map((flavor) => {
						const isSelected = value.includes(flavor);
						const count = getCount(flavor);
						const isDisabled = count === 0 && !isSelected;
						return (
							<ToggleGroup.Item
								key={flavor}
								value={flavor}
								className="capitalize"
								disabled={isDisabled}
							>
								{/* @ts-ignore: dynamic key generation */}
								{t(`filters.flavors.${flavor}`)}
							</ToggleGroup.Item>
						);
					})}
				</ToggleGroup.Root>
			</Accordion.Content>
		</Accordion.Item>
	);
}
